// @ts-nocheck

// Meta Pixel fixo do site (independente do pixel dinâmico por evento
// já usado via `react-facebook-pixel` em Event/PaymentMethod/OrderProcess).
// Eventos são disparados com `trackSingle`, restritos a este pixel, para
// não interferir nos eventos do pixel por evento e vice-versa.

const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID

let baseInitialized = false

const loadPixelScript = () => {
  if (window.fbq) return

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = true
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */
}

export const initMetaPixel = () => {
  if (baseInitialized || !PIXEL_ID) return

  loadPixelScript()
  window.fbq('init', PIXEL_ID)
  baseInitialized = true
}

const trackMeta = (event: string, data?: Record<string, unknown>) => {
  if (!baseInitialized || !PIXEL_ID) return
  window.fbq('trackSingle', PIXEL_ID, event, data)
}

export const trackMetaPageView = () => trackMeta('PageView')

export const trackMetaViewContent = ({
  id,
  name
}: {
  id: string
  name?: string
}) =>
  trackMeta('ViewContent', {
    content_ids: [id],
    content_name: name,
    content_type: 'product'
  })

export const trackMetaPurchase = ({
  value,
  contentIds,
  currency = 'BRL'
}: {
  value: number
  contentIds: string[]
  currency?: string
}) =>
  trackMeta('Purchase', {
    value,
    currency,
    content_ids: contentIds,
    content_type: 'product'
  })
